import React from 'react';
import {
    Box,
    FormControl,
    Grid,
    TextField,
    Typography,
    InputLabel,
    FormHelperText
} from '@mui/material';
import '../MakeMyDonationComponent/MakeMyDonationComponent.css';
import { getDonationdetails } from '../../store/actions/donation.js';
import { connect } from "react-redux";
import { useImmer } from 'use-immer';

const MakeMyDonationComponent = ({

    Donationdetails,
    getuserDonationdetails,
    setuserDonationdetails



}) => {

    const ErrorInitialState = {
        error: false,
        message: ""
    }

    const [isNameSelected, setIsNameSelected] = useImmer(false);
    const [isContactNumberValid, setIsContactNumberValid] = useImmer(true);
    const [AltContactPersonError, setPersonAltContactPersonError] = useImmer(ErrorInitialState);
    const [MailPersonPinCodeError, setMailPersonPinCodeError] = useImmer(false);
    const [DonationID, setDonationID] = useImmer('');
    const [isComments, setComments] = useImmer(ErrorInitialState);

    React.useEffect(() => {
        setDonationID(Donationdetails.DonationID);

    }, [Donationdetails])




    const handlePersonName = (event) => {
        let data = event.target.value;

        // Trim leading spaces and allow Unicode letters, numbers, spaces, parentheses, and combining marks
        data = data
            .trimStart()
            .replace(/[^\p{L}\p{N}\p{M} ()]/gu, ""); // Include combining marks

        setuserDonationdetails((draft) => {
            draft.donationUserName.value = data;
            draft.donationUserName.isValid = data.trim() ? true : false; // Prevent spaces-only inputs
        });
    };



    const handleAmount = (event) => {
        let amount = event.target.value.trim();

        // Ensure only numeric input is allowed and restrict to 6 digits
        const isNumeric = /^[0-9]*$/;
        if (isNumeric.test(amount) && amount.length <= 6) {
            setuserDonationdetails((draft) => {
                draft.Amount.value = amount;

                const amountNumber = parseInt(amount, 10);

                // Validate if the amount is within valid range
                if (amount === "" || amountNumber <= 0) {
                    draft.Amount.isValid = false;
                    draft.Amount.errorMesssage = "Please enter Donation Amount";
                } else if (amountNumber > 100000) {
                    draft.Amount.isValid = false;
                    draft.Amount.errorMesssage = "Amount should not exceed 100,000";
                } else {
                    draft.Amount.isValid = true;
                    draft.Amount.errorMesssage = "";
                }
            });
        }
    };



    const handlePersonContactNumber = (event) => {
        const contactNumber = event.target.value.trim();
        const isValid = /^[0-9]*$/;

        if (contactNumber.length <= 10 && isValid.test(contactNumber) && !/^0+$/.test(contactNumber)) {
            setuserDonationdetails((draft) => {
                draft.donationUserContact.value = contactNumber; // <-- fix: use .value
                draft.donationUserContact.isValid = contactNumber.length === 10; // optional: add validity
            });
            setIsContactNumberValid(true);
        } else {
            setIsContactNumberValid(false);
        }

        if (/^0+$/.test(contactNumber)) {
            setIsContactNumberValid(false);
        }

        // If alternate number is filled, check if it's the same as contact number
        if (
            contactNumber.length === 10 &&
            getuserDonationdetails.donationUserAlt.value.length === 10 && // <-- fix: use .value
            contactNumber === getuserDonationdetails.donationUserAlt.value // <-- fix: use .value
        ) {
            setPersonAltContactPersonError((draft) => {
                draft.error = true;
                draft.message = "Contact Number and Alternate Number should not be the same";
            });
        } else if (
            getuserDonationdetails.donationUserAlt.value.length === 10 && // <-- fix: use .value
            contactNumber !== getuserDonationdetails.donationUserAlt.value // <-- fix: use .value
        ) {
            setPersonAltContactPersonError((draft) => {
                draft.error = false;
                draft.message = "";
            });

        }
    };


    const handlePersonAltNumber = (event) => {
        const alternateNumber = event.target.value.trim();
        const isValid = /^[0-9]*$/;

        if (alternateNumber.length <= 10 && isValid.test(alternateNumber) && !/^0+$/.test(alternateNumber)) {
            setuserDonationdetails((draft) => {
                draft.donationUserAlt.value = alternateNumber; // <-- fix: use .value
            });
            setPersonAltContactPersonError((draft) => {
                draft.error = false;
                draft.message = "";
            });
        }

        if (alternateNumber.length > 0 && alternateNumber.length < 10) {
            setPersonAltContactPersonError((draft) => {
                draft.error = true;
                draft.message = "Enter a valid alternate number";
            });
        }
        if (alternateNumber === getuserDonationdetails.donationUserContact.value) { // <-- fix: use .value
            setPersonAltContactPersonError((draft) => {
                draft.error = true;
                draft.message = "Contact Number and Alternate Number should not be the same";
            });
        }

        if (/^0+$/.test(alternateNumber)) {
            setPersonAltContactPersonError((draft) => {
                draft.error = true;
                draft.message = "";
            });
        }

    };
    // const handleMailPersonName = (event) => {
    //     setuserDonationdetails((draft) => {
    //     draft.donationemailName.value= event.target.value;
    //     })
    // };

    const handleMailPersonAddress = (event) => {
        const value = event.target.value;
        // Regex to allow valid characters including #
        const validAddressRegex = /^[\p{L}\p{N}\p{M}\s,.'-/&]*$/u;
        if (validAddressRegex.test(value) || value === '') {
            setuserDonationdetails((draft) => {
                draft.donationemailAddress.value = value;
            });
        }
    };


    const handleMailPersonPinCode = (event) => {
        let pincode = event.target.value;
        if (pincode.startsWith(' ')) {
            pincode = pincode.trimStart();
        }
        const regex = /^[a-zA-Z0-9]*$/; // Allow alphanumeric characters

        setuserDonationdetails((draft) => {
            draft.donationemailPincode.value = pincode;
            // Validation: length between 3 and 10, and only alphanumeric
            if (pincode.length === 0) {
                draft.donationemailPincode.isValid = true;
                draft.donationemailPincode.errorMessage = "";
            } else if (!regex.test(pincode)) {
                draft.donationemailPincode.isValid = false;
                draft.donationemailPincode.errorMessage = "Please enter valid Pincode";
            } else if (pincode.length < 4 || pincode.length > 10) {
                draft.donationemailPincode.isValid = false;
                draft.donationemailPincode.errorMessage = "Please enter valid Pincode";
            } else {
                draft.donationemailPincode.isValid = true;
                draft.donationemailPincode.errorMessage = "";
            }
        });

        // For backward compatibility with your old error state
        if (!regex.test(pincode) || (pincode.length > 0 && (pincode.length < 4 || pincode.length > 10))) {
            setMailPersonPinCodeError(true);
        } else {
            setMailPersonPinCodeError(false);
        }
    };

    const handlebookComments = (event) => {
        const Comments = event.target.value;
        setuserDonationdetails((draft) => {
            draft.userComments.value = Comments;
            // Validate only if comments exceed 120 characters
            draft.userComments.isValid = Comments.length <= 120;
        });
    }

    const HandlePan = (event) => {
        const Pan = event.target.value.trim().toUpperCase();
        const regpan = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

        setuserDonationdetails((draft) => {
            draft.userPanNo.value = Pan;
            draft.userPanNo.isValid = Pan === "" || regpan.test(Pan); // valid if empty or matches regex
            draft.userPanNo.errorMessage = Pan !== "" && !regpan.test(Pan) ? "Please enter a valid PAN number" : "";
        });
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const handlebookEmail = (event) => {
        const email = event.target.value.trim().toLowerCase();

        setuserDonationdetails((draft) => {
            draft.userEmail.value = email;

            if (emailRegex.test(email)) {
                draft.userEmail.isValid = true; // Mark as valid
                draft.userEmail.error = ""; // Clear error message
            } else {
                draft.userEmail.isValid = false; // Mark as invalid
                draft.userEmail.error = "Invalid email format"; // Set error message
            }
        });
    };





    return (
        <>
            <Box
                className='donation-booking'
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1 },
                    mx: 20,
                    pt: 6
                }}
                noValidate
                autoComplete="off"
            >
                <div>
                    <Box sx={{ mb: 4 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>Purpose</label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="body1">{Donationdetails.DonationName}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ mb: 4 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>Amount <span className="label-required">*</span></label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        type="number"
                                        inputMode="numeric"
                                        value={getuserDonationdetails.Amount.value}
                                        onChange={handleAmount}
                                        inputProps={{ maxLength: 6 }}
                                    />
                                </FormControl>
                                {/* Show error messages based on validation */}
                                {!getuserDonationdetails.Amount.isValid && (
                                    <FormHelperText error>
                                        {getuserDonationdetails.Amount.errorMesssage}
                                    </FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ mb: 4 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>Your Name  <span className="label-required">*</span></label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        value={getuserDonationdetails.donationUserName.value}
                                        onChange={handlePersonName}
                                    />
                                </FormControl>
                                {getuserDonationdetails.donationUserName.value == "" && (
                                    <FormHelperText error>
                                        Please enter a valid Name
                                    </FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ mb: 4 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>
                                        Your Contact WhatsApp# <span className="label-required">*</span>
                                    </label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        type="text"
                                        inputMode="numeric"
                                        value={getuserDonationdetails.donationUserContact.value} // <-- fix: use .value
                                        onChange={handlePersonContactNumber}
                                    />
                                </FormControl>
                                {getuserDonationdetails.donationUserContact.value.length < 10 && (
                                    <FormHelperText error>Please enter a valid 10-digit contact number</FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ mb: 4 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>Alternate Mobile No#</label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        type="text"
                                        value={getuserDonationdetails.donationUserAlt.value} // <-- fix: use .value
                                        onChange={handlePersonAltNumber}
                                    />
                                    {AltContactPersonError.error && (
                                        <FormHelperText error>{AltContactPersonError.message}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ mb: 4 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>Your PAN <span className='label-required'></span></label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        value={getuserDonationdetails.userPanNo.value}
                                        onChange={HandlePan}
                                        inputProps={{ maxLength: 10 }}
                                        error={getuserDonationdetails.userPanNo.value !== "" && !getuserDonationdetails.userPanNo.isValid}
                                    />
                                    {getuserDonationdetails.userPanNo.value !== "" && !getuserDonationdetails.userPanNo.isValid && (
                                        <FormHelperText error>
                                            {getuserDonationdetails.userPanNo.errorMessage}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ mb: 4 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>Your Email ID</label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        value={getuserDonationdetails.userEmail.value}
                                        onChange={handlebookEmail}
                                    />
                                    {!getuserDonationdetails.userEmail.isValid && (
                                        <FormHelperText error>
                                            {getuserDonationdetails.userEmail.errorMessage}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box>
                        <Typography sx={{ pb: 4, fontWeight: '600', color: '#010101' }}>Your Address</Typography>
                        {/* <Box sx={{ mb: 4 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box>
                                    <label>Name</label>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <FormControl fullWidth>
                                    <TextField 
                                        id="outlined-basic" 
                                        variant="outlined" 
                                        value={getuserDonationdetails.donationemailName.value} 
                                        onChange={handleMailPersonName}  
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box> */}
                        <Box sx={{ mb: 4 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <label>Address</label>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormControl fullWidth>
                                        <TextField multiline
                                            rows="4"
                                            id="outlined-basic"
                                            variant="outlined"
                                            value={getuserDonationdetails.donationemailAddress.value}
                                            onChange={handleMailPersonAddress}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ mb: 4 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <label>Pin Code</label>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            type="text"
                                            value={getuserDonationdetails.donationemailPincode.value}
                                            onChange={handleMailPersonPinCode}
                                            error={!getuserDonationdetails.donationemailPincode.isValid}
                                        />
                                        {!getuserDonationdetails.donationemailPincode.isValid && (
                                            <FormHelperText error>
                                                {getuserDonationdetails.donationemailPincode.errorMessage}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ mb: 4 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <label>Comments</label>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            multiline
                                            rows={4}
                                            value={getuserDonationdetails.userComments.value}
                                            onChange={handlebookComments}
                                            error={!getuserDonationdetails.userComments.isValid}
                                        />
                                        <span>{getuserDonationdetails.userComments.value.length}/120</span>
                                        {
                                            !getuserDonationdetails.userComments.isValid && (
                                                <FormHelperText error>
                                                    {getuserDonationdetails.userComments.errorMessage}
                                                </FormHelperText>
                                            )
                                        }
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </div>
            </Box>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        Donationdetails: state.donation.donationDetails
    };
}


export default connect(mapStateToProps, {
    getDonationdetails,

})(MakeMyDonationComponent);
